export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8632.87e54de3.jpg";